import { StateSchema } from 'app/config/storeConfig/types';
import { UploadModalSchema } from '../types';

export const getUploadModalState = (state: StateSchema): UploadModalSchema => state.uploadModal;
